// Main JS file
document.addEventListener('DOMContentLoaded', () => {
  AOS.init();

  const aboutSwiper = new Swiper(".j-about-swiper", {
    slidesPerView: 1,
    spaceBetween: 12,
    loop: true,
    autoplay: {
      delay: 2000,
    },
    effect: "cube",
    cubeEffect: {
      shadow: true,
      slideShadows: true,
      shadowOffset: 20,
      shadowScale: 0.94,
    }
  });

  const companySwiper = new Swiper(".j-company-swiper", {
    slidesPerView: 1,
    spaceBetween: 12,
    loop: true,
    autoplay: {
      delay: 2000,
    },
    effect: "cube",
    cubeEffect: {
      shadow: true,
      slideShadows: true,
      shadowOffset: 20,
      shadowScale: 0.94,
    }
  });
});
